<template>
  <v-card>
    <v-card-title class="pt-6"> Payments </v-card-title>
    <v-card-text>
      <v-data-table
        :loading="loading"
        :items="payments"
        item-key="id"
        :headers="headers"
      >
        <template v-slot:item.paymentTerm="{ item }">
          {{ item.paymentTerm ? item.paymentTerm : "Receipt" }}
        </template>

        <template v-slot:item.amount="{ item }">
          {{ item.amount | dollarsCents }}
        </template>

        <template v-slot:item.subscriptionCharges="{ item }">
          {{ item.subscriptionCharges | dollarsCents }}
        </template>

        <template v-slot:item.clicksBilled="{ item }">
          {{ item.clicksBilled | dollarsCents }}
        </template>
        <template v-slot:item.avgClickPrice="{ item }">
          {{ item.avgClickPrice | dollarsCents }}
        </template>

        <template v-slot:item.avgCallPrice="{ item }">
          {{ item.avgCallPrice | dollarsCents }}
        </template>
        <template v-slot:item.callsBilled="{ item }">
          {{ item.callsBilled | dollarsCents }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            outlined
            fab
            x-small
            color="primary"
            :to="{
              name: 'paymentShow',
              params: {
                companyId: $route.params.companyId,
                paymentId: item.id
              }
            }"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>

          <v-btn
            :loading="pendingInvoiceId === item.id"
            outlined
            fab
            x-small
            color="primary"
            :to="{
              name: 'paymentShow',
              params: {
                companyId: $route.params.companyId,
                paymentId: item.id,
                download: true
              }
            }"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { getCompanyPayments } from "../../api/company";
import { getPaymentInvoice, createPaymentInvoice } from "../../api/payment";

export default {
  name: "Payments",
  title: "Payments",
  data() {
    return {
      loading: false,
      payments: [],
      pendingInvoiceId: null,
      pendingInvoiceInterval: null,

      headers: [
        { text: "Payment ID", value: "id" },
        { text: "Payment Terms", value: "paymentTerm" },
        { text: "Amount", value: "amount" },
        { text: "Monthly Upgrade Fees", value: "subscriptionCharges" },
        { text: "Number of Clicks", value: "numClicks" },
        { text: "Avg Click Price", value: "avgClickPrice" },
        { text: "Click Charges", value: "clicksBilled" },
        { text: "Number of Calls", value: "numCalls" },
        { text: "Avg Call Price", value: "avgCallPrice" },
        { text: "Call Charges", value: "callsBilled" },
        { text: "Date", value: "createdAt" },
        { text: "", value: "actions" }
      ]
    };
  },

  props: {
    companyId: [String, Number]
  },

  watch: {
    companyId: function() {
      this.getPayments();
    }
  },

  mounted() {
    this.getPayments();
  },

  methods: {
    async getPayments() {
      const companyId = parseInt(this.companyId);
      if (companyId) {
        this.loading = true;
        const result = await getCompanyPayments(companyId);
        this.payments = result.payments;
        this.loading = false;
      }
    },
    async downloadPaymentInvoice(id) {
      this.pendingInvoiceId = id;
      await createPaymentInvoice(id);
      this.pollInterval = setInterval(this.getPaymentInvoice(id), 5000);
    },
    async getPaymentInvoice(id) {
      const result = await getPaymentInvoice(id);
      if (!result.completed || !result.url) {
        return;
      }

      // @TODO: need to actually download from the URL
      clearInterval(this.pollInterval);
      this.pendingInvoiceId = null;
    }
  }
};
</script>

<style scoped></style>
